import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';
import Employee from 'main/stores/employees/Employee';
import CheckInSummary from 'main/stores/performance/CheckInSummary';
import {makeAutoObservable} from 'mobx';

class AdminCheckInState {
  checkInState;
  match;

  constructor() {
    makeAutoObservable(this, {
      checkInState: false
    });
  }

  receiveProps({checkInState, match}) {
    this.checkInState = checkInState;
    this.match = match;
  }

  async load() {
    const store = new DomainStore();
    await store._compose([
      endpoints.EMPLOYEES.ALL,
      endpoints.PERFORMANCE.CYCLE_REVIEWEES.with(this.match.params.id, this.match.params.employeeId)
    ]);

    this.checkInState.allCheckins = store._getAll(types.PERFORMANCE.CHECKIN).map(c => new CheckInSummary(c));
    this.checkInState.sortAllCheckins();
    this.checkInState.selectedReviewee = new Employee(store._getSingle(types.EMPLOYEE, {id: this.match.params.employeeId}));
    await this.checkInState.selectFirstCheckin();
  }

  onCheckInSelected = async (checkin) => {
    return this.checkInState.selectCheckIn(checkin);
  };
}

export default AdminCheckInState;
